import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "aws-amplify/auth";
import * as Sentry from "@sentry/react";
import { useAppDispatch } from "@store/store";
import { setModalErrorVisible } from "@store/slices/appSlice";
import { ApiError } from "@interfaces/response";
import { PATHS_AUTH_V2 } from "@helpers/constantes";

/**
 * Cierre de sesión del wizard v2, igual que el Navbar legacy: cierra la sesión de Cognito, limpia el
 * `sessionStorage`, avisa a las demás pestañas abiertas (canal `session`) y lleva al login del v2.
 */
const useSignOut = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isSigningOut, setIsSigningOut] = useState(false);

  const signOutAndRedirect = async () => {
    setIsSigningOut(true);
    try {
      await signOut();
      sessionStorage.clear();
      const channel = new BroadcastChannel("session");
      channel.postMessage("logout");
      channel.close();
      navigate(PATHS_AUTH_V2.login.path);
    } catch (error) {
      Sentry.captureException(error, { extra: { component: "useSignOut" } });
      dispatch(setModalErrorVisible({ open: true, error: error as ApiError }));
    } finally {
      setIsSigningOut(false);
    }
  };

  return { signOutAndRedirect, isSigningOut };
};

export default useSignOut;
